module.exports = __webpack_public_path__ + "img/india_mart_certificate.81faa892.jpg";